/**
 * Error levels correlate with error boundaries in the application. It loosely
 * described where that error boundary might be found, and is also used to show
 * an appropriate fallback UI for that level.
 */
export enum ErrorLevel {
  HOST = 1,
  TEMPLATE,
  OBJECT,
  GROUP,
  COMPONENT,
}

/**
 * Unique, known error codes that might surface in the Platform UI. These should
 * not duplicate or replace error codes delivered in API responses, but instead
 * represent errors that are caused by client-side code, or are not yet known or
 * handled by a Platform API.
 */
export enum UIErrorCode {
  UNKNOWN = 'Unknown', // Catch-all for errors that we still need to handle
  TEMPLATE_NOT_FOUND = 'TemplateNotFound',
  TEMPLATE_RENDER_FAILED = 'TemplateRenderFailed',
  RESOURCE_NOT_FOUND = 'ResourceNotFound',
  LIST_NOT_FOUND = 'ListNotFound',
  VALIDATION_NOT_FOUND = 'ValidationNotFound',
  DATA_TABLE_INVALID_LIST = 'DataTableInvalidList',
  DATA_TABLE_MISSING_SCHEMA = 'DataTableMissingSchema',
  REFLECTIVE_TABS_INVALID_TABS = 'ReflectiveTabsInvalidTabsList',
  HORIZON_COMPONENT_NOT_FOUND = 'HorizonComponentNotFound',
  HORIZON_COMPONENT_INVALID = 'HorizonComponentInvalid',
  CORE_CONTEXT_NOT_FOUND = 'CoreContextNotFound',
  COMPONENT_NOT_REGISTERED = 'ComponentNotRegistered',
}

export const DEV_DOCS_PLATFORM_ERROR_CODES_URL =
  'https://developer.skedulo.com/docs/customization/platform/error-codes'
export const SKEDULO_SYSTEM_STATUS_URL = 'https://status.skedulo.com'

export enum PagesPermission {
  ENHANCED_ERRORS = 'skedulo.tenant.pages.enhancedErrors',
  MODIFY = 'skedulo.tenant.pages.modify',
}
